import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import { Typography, Row, Col, Button, Card, Spin } from "antd";

import UserForm from "../../../../Components/UserForm";
import DistrictSubProperty from "../../../../Components/DistrictSubProperty";
import { getDistricts } from "../../../../actionCreators/DropDown";
import { getCirclesOfDistrict } from "../../../../actionCreators/Circles";
import {
  addTaxInspector,
  resetAddTaxInspector,
} from "../../../../actionCreators/TaxInspector";
import ResponseModal from "../../../../Components/ResponseModal";
const { Text } = Typography;
function AddTaxInspector({
  getDistricts,
  districts,
  getCirclesOfDistrict,
  circlesOfDistrict,
  addTaxInspector,
  addTaxInspectorResponse,
  resetAddTaxInspector,
}) {
  const styles = {
    titleButtonParent: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    uploadButton: {
      padding: "7px 18px",
      background: "#284F68",
      color: "white",
      borderRadius: "5px",
      fontWeight: "500",
      fontSize: "15px",
      cursor: "pointer",
      marginRight: "8px",
    },
    contentWrapper: {
      marginLeft: "10px",
      marginRight: "10px",
    },
    titleText: {
      color: "#9e9e9e",
    },
    firstButton: {
      marginRight: "10px",
    },
    assignmentTitle: {
      fontSize: "20px",
    },
  };

  const handleSubmit = (identityForm, assignmentForm) => {
    const obj = {
      fullName: identityForm?.name,
      email: identityForm?.email,
      phone: identityForm?.phone,
      status: identityForm?.status === 1 ? "active" : "inactive",
      circleId: assignmentForm?.circles?.map((x) => x?.id) ?? [],
    };
    addTaxInspector(obj);
  };

  const history = useHistory();
  const [disableInviteButton, setDisableInviteButton] = React.useState(false);
  const [identityForm, setIdentityForm] = React.useState(null);
  const [assignmentForm, setAssignmentForm] = React.useState(null);

  React.useEffect(() => {
    getDistricts();
  }, []);

  if (![null, undefined].includes(addTaxInspectorResponse?.data)) {
    return (
      <ResponseModal
        closeAction={() => {
          resetAddTaxInspector();
          history.goBack();
        }}
        addAction={() => {
          resetAddTaxInspector();
        }}
        isSuccess={true}
      />
    );
  } else if (![null, undefined].includes(addTaxInspectorResponse?.error)) {
    return (
      <ResponseModal
        closeAction={() => {
          resetAddTaxInspector();
          history.goBack();
        }}
        addAction={() => {
          resetAddTaxInspector();
        }}
        isSuccess={false}
        message={addTaxInspectorResponse?.error}
      />
    );
  } else
    return (
      <React.Fragment>
        {addTaxInspectorResponse?.loading ? (
          <div className="spin-loader">
            <Spin size="large" />
          </div>
        ) : (
          <>
            <div style={styles.titleButtonParent}>
              <div>
                <Typography className="heading">
                  <span style={styles.titleText}>Tax Inspector</span>/ Add Tax
                  Inspector
                </Typography>
              </div>
              <div>
                <Button
                  style={styles.firstButton}
                  danger
                  color={"orange"}
                  size={"large"}
                  onClick={() => history.goBack()}
                >
                  Cancel
                </Button>
                <Button
                  style={
                    !disableInviteButton
                      ? styles.uploadButton
                      : { color: "grey" }
                  }
                  type="primary"
                  size={"large"}
                  onClick={() => handleSubmit(identityForm, assignmentForm)}
                  disabled={disableInviteButton}
                >
                  SEND INVITE
                </Button>
              </div>
            </div>
            <Card bordered={false}>
              <UserForm
                columnConfig={{
                  name: { isRequired: true, isDisabled: false },
                  email: { isRequired: true, isDisabled: false },
                  phone: { isRequired: true, isDisabled: false },
                  status: { isDisabled: true },
                }}
                toggleUpdateDisability={(x) => setDisableInviteButton(x)}
                updateFormState={(x) => setIdentityForm(x)}
              />
              <div style={styles.assignmentTitle}>Assignment</div>

              <DistrictSubProperty
                subPropertyOfDistrict={circlesOfDistrict?.data}
                getSubPropertyOfDistrict={(x) =>
                  getCirclesOfDistrict({ districtId: x })
                }
                initialDistrictValue={districts?.data}
                updateFormState={(x) => setAssignmentForm(x)}
                isCircle={true}
              />
              <Col
                span={24}
                style={{ marginTop: "20px", marginBottom: "-20px" }}
              >
                <Text type="danger">
                  Note: If no circles are available, then you can save the user
                  and reassign circles to the user later.
                </Text>
              </Col>
            </Card>
          </>
        )}
      </React.Fragment>
    );
}

const mapStateToProps = ({
  user: user,
  dropDown: { districts },
  circles: { circlesOfDistrict },
  taxInspector: { addTaxInspectorResponse },
}) => ({
  user,
  districts,
  circlesOfDistrict,
  addTaxInspectorResponse,
});

const mapDispatchToProps = (dispatch) => ({
  getDistricts: bindActionCreators(getDistricts, dispatch),
  getCirclesOfDistrict: bindActionCreators(getCirclesOfDistrict, dispatch),
  addTaxInspector: bindActionCreators(addTaxInspector, dispatch),
  resetAddTaxInspector: bindActionCreators(resetAddTaxInspector, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddTaxInspector);
